import { motion } from "framer-motion";
import { IuniFlower } from "./IuniFlower";

export default function ThankYouOverlay({ onReset }) {
  const handleReset = () => {
    onReset();
    window.scrollTo(0, 0);
  };

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.5, ease: "easeOut" }}
      className="fixed inset-0 z-[100] bg-white flex flex-col items-center justify-center px-6 text-center"
      data-testid="thank-you-overlay"
    >
      <motion.div
        initial={{ scale: 0.6, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ delay: 0.15, type: "spring", stiffness: 120, damping: 14 }}
        className="relative w-28 h-28 rounded-full flex items-center justify-center"
        style={{
          background:
            "linear-gradient(#fff, #fff) padding-box, linear-gradient(135deg, #E07A5F, #E2856E) border-box",
          border: "2px solid transparent",
          boxShadow: "0 20px 60px -12px rgba(224, 122, 95, 0.35)",
        }}
        data-testid="thank-you-icon"
      >
        <IuniFlower size={56} />
      </motion.div>

      <motion.h1
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.3, duration: 0.6 }}
        className="font-display text-4xl sm:text-5xl lg:text-6xl tracking-tight text-[#1A1A1A] mt-10 max-w-2xl"
        data-testid="thank-you-title"
      >
        Sei ufficialmente in lista d'attesa.
      </motion.h1>

      <motion.p
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.45, duration: 0.6 }}
        className="text-gray-500 max-w-md mt-6 leading-relaxed text-base"
        data-testid="thank-you-body"
      >
        Grazie per aver richiesto l'accesso. Stiamo selezionando con cura le prime 50 coppie per il
        programma Beta di iuni. Tieni d'occhio la tua casella email: ti contatteremo non appena si
        libererà un posto per il tuo evento.
      </motion.p>

      <motion.button
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.6, duration: 0.6 }}
        onClick={handleReset}
        data-testid="thank-you-home-button"
        className="mt-10 px-8 py-3.5 text-sm font-medium text-gray-600 border border-gray-200 rounded-xl hover:border-[#E07A5F]/50 hover:text-[#C2492F] hover:bg-[rgba(224,122,95,0.04)] transition-colors"
      >
        Torna alla Home
      </motion.button>
    </motion.div>
  );
}
